export default "__VITE_ASSET__CFV_Y29B__"